// A generated tile's link comes before its delete button, so the link is the one found.
// The Generate tile is itself the button, so the tile is checked as well as its contents.
const TILE_FOCUS_TARGET = 'a[href], button:not([disabled])'

export interface TilePosition {
  strip: HTMLElement
  index: number
}

export function tilePosition(tile: HTMLElement): TilePosition | null {
  const strip = tile.parentElement
  if (!strip) {
    return null
  }
  return { strip, index: Array.from(strip.children).indexOf(tile) }
}

function focusTargetNear({ strip, index }: TilePosition): HTMLElement | null {
  const tiles = Array.from(strip.children)
  const tileInSlot = tiles[index] ?? tiles[index - 1]
  if (!(tileInSlot instanceof HTMLElement)) {
    return null
  }
  if (tileInSlot.matches(TILE_FOCUS_TARGET)) {
    return tileInSlot
  }
  return tileInSlot.querySelector<HTMLElement>(TILE_FOCUS_TARGET)
}

// Focuses the strip itself once it has no tiles left, so the user stays in the region they
// were working in. The tabindex is removed again on blur because the strip belongs to the
// page, not to the removed tile.
function focusEmptyStrip(strip: HTMLElement) {
  strip.setAttribute('tabindex', '-1')
  strip.addEventListener('blur', () => strip.removeAttribute('tabindex'), { once: true })
  strip.focus()
}

// Without this, focus falls to <body> when the focused tile is removed.
export function focusAfterTileRemoval(position: TilePosition) {
  if (!document.body.contains(position.strip)) {
    return
  }
  const focusTarget = focusTargetNear(position)
  if (focusTarget) {
    focusTarget.focus()
    return
  }
  focusEmptyStrip(position.strip)
}
